import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
export enum Column {
  DOMAIN = 1,
  IPS_COUNT = 2,
  IP_MASK = 3,
}
export enum ColumnKeys {
  DOMAIN = 'domain',
  IPS_COUNT = 'ipsCount',
  IP_MASK = 'ipsString',
}

export const GRID_COLUMNS = [Column.DOMAIN, Column.IPS_COUNT, Column.IP_MASK];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.DOMAIN, ColumnKeys.IP_MASK];
export const FILTERS = [{ [ColumnKeys.DOMAIN]: { contains: '' } }, { [ColumnKeys.IP_MASK]: { contains: '' } }];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.DOMAIN,
      key: ColumnKeys.DOMAIN,
      columnName: translateFn('Domain name'),
      type: ColumnType.STRING,
      sortable: true,
      removable: false,
    },
    {
      column: Column.IPS_COUNT,
      key: ColumnKeys.IPS_COUNT,
      columnName: translateFn('IP filters count'),
      type: ColumnType.NUMBER,
      filteringDisabled: true,
      sortable: true,
      removable: false,
    },
    {
      column: Column.IP_MASK,
      key: ColumnKeys.IP_MASK,
      columnName: translateFn('IP/mask'),
      type: ColumnType.STRING,
      sortable: true,
      removable: false,
    },
  ];
}
export function domainNameRenderer(rowData: any, columnDetails: ColumnDetails<Column, ColumnKeys>): TemplateResult {
  return html`<div
    class="text-medium"
    style="cursor: pointer; color: var(--blue-layout-400-primary); "
    @click="${() => this.openEditDialog(rowData)}"
  >
    ${rowData.item['domain']}
  </div>`;
}
